// Vendored aus appeulektro — Typen hier inline statt aus ~/types/uiPreferences.
export type DesignTheme = "light" | "dark" | "auto";
export type ResolvedTheme = "light" | "dark";

const MEDIA_QUERY = "(prefers-color-scheme: dark)";

/**
 * Löst eine Theme-Präferenz zum konkret anliegenden Theme auf.
 * "auto" folgt dem OS via prefers-color-scheme; SSR-Fallback ist "light".
 */
export function resolveTheme(pref: DesignTheme): ResolvedTheme {
  if (pref === "auto") {
    if (typeof window !== "undefined" && typeof window.matchMedia === "function") {
      return window.matchMedia(MEDIA_QUERY).matches ? "dark" : "light";
    }
    return "light";
  }
  return pref;
}

/**
 * Schreibt das aufgelöste Theme nach body[data-theme] UND toggelt body.dark.
 * Trägt NIE "auto" ins DOM — die CSS-Tokens schalten über [data-theme="dark"],
 * Tailwind-dark:-Utilities über die .dark-Klasse (darkMode:"class"). Beide werden
 * synchron gehalten, damit kein Mismatch/Flicker entsteht. Reine Client-Funktion.
 */
export function applyThemePreference(pref: DesignTheme): void {
  if (typeof document === "undefined") return;
  const resolved = resolveTheme(pref);
  document.body.dataset.theme = resolved;
  document.body.classList.toggle("dark", resolved === "dark");
}
